<template>
  <div v-if="availableProfiles.length" class="flex items-end mx-0 my-2 gap-3">
    <a
      v-for="profile in availableProfiles"
      :key="profile.key"
      :href="`${profile.link}${socialProfiles[profile.key]}`"
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      <fluent-icon
        v-if="profile.key === 'github'"
        :icon="`brand-${profile.key}`"
        size="16"
        class="text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200"
      />
      <img v-else :src="profile.icon" :alt="profile.key" />
    </a>
  </div>
</template>

<script>
import FacebookIcon from 'dashboard/assets/images/contact-socials/facebook.svg';
import InstagramIcon from 'dashboard/assets/images/contact-socials/instagram.svg';
import LinkedInIcon from 'dashboard/assets/images/contact-socials/linkedIn.svg';
import TwitterIcon from 'dashboard/assets/images/contact-socials/twitter.svg';

export default {
  props: {
    socialProfiles: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      socialMediaLinks: [
        { key: 'facebook', icon: FacebookIcon, link: 'https://facebook.com/' },
        { key: 'twitter', icon: TwitterIcon, link: 'https://twitter.com/' },
        { key: 'linkedin', icon: LinkedInIcon, link: 'https://linkedin.com/' },
        { key: 'github', icon: 'github', link: 'https://github.com/' },
        {
          key: 'instagram',
          icon: InstagramIcon,
          link: 'https://instagram.com/',
        },
      ],
    };
  },
  computed: {
    availableProfiles() {
      return this.socialMediaLinks.filter(
        mediaLink => !!this.socialProfiles[mediaLink.key]
      );
    },
  },
};
</script>
